const toaster = {
  show(message, type) {
    const body = document.querySelector('body');

    body.insertAdjacentHTML('beforeend', `<div class="toast ${type}">${message}</div>`);
    const toastElement = document.querySelector('.toast:last-child');

    setTimeout(() => {
      toastElement.classList.add('show');
    }, 0);

    setTimeout(() => {
      toastElement.classList.remove('show');
      setTimeout(() => {
        toastElement.remove();
      }, 300);
    }, 5000);
  },

  error(message) {
    this.show(message, 'error');
  },

  message(message) {
    this.show(message, 'message');
  },

  warning(message) {
    this.show(message, 'warning');
  },
};
